export default __webpack_public_path__ + "static/media/ai-col-star-gradient.afeeaca5.svg";